import React from "react";
import { useDispatch } from "react-redux";
import { openPinnacleMessageModal } from "../actions/pinnacleMessage";
import PinnacleFoundationLogoImage from "../images/pinnacle_foundation_logo.jpg";

const PinnacleFoundationLogo = () => {
  const dispatch = useDispatch();

  return (
    <img
      alt="Pinnacle Foundation Logo"
      src={PinnacleFoundationLogoImage}
      onClick={() => dispatch(openPinnacleMessageModal())}
    />
  );
};

export default PinnacleFoundationLogo;
